import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { util } from '../../../../classes/util';
import { ESRI } from '../../../../esri-loader-util';
import { InputConverter } from '../../../../inputConverter';
import { LayerService } from '../../../../services/layer.service';
import { BaseComponent } from '../../../base.component';
import AreaMeasurementConfiguration, { AreaMeasureConfigurationConverter } from './area.config';
var initilizeDebounceTime = 50;
var AreaComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AreaComponent, _super);
    function AreaComponent(_vcr, layerService, LoggingService, UserSettingsService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.LoggingService = LoggingService;
        _this.UserSettingsService = UserSettingsService;
        _this.activeChange = new EventEmitter();
        _this._active = false;
        _this._autolayer = false;
        /**
         * Object containing default settings for this component.
         */
        _this.areaMeasurementConfigs = new AreaMeasurementConfiguration();
        /**
         * Measure component will find users default values and give those priority over other settings.
         */
        _this.includeUserDefault = true;
        /**
         * Display the Measure interface while drawing measurement.
         *
         * When set to false the user will be able to draw the distance line but not start a new distance line.
         *
         * @Default true
         *
         */
        _this.showDialog = true;
        _this.stateChange = new EventEmitter();
        _this._state = 'disabled';
        _this.onmeasure = new EventEmitter();
        _this.initializing = false;
        _this.listners = [];
        _this.registerEvent('stateChange', _this.stateChange);
        _this.registerEvent('activeChange', _this.activeChange);
        _this.registerEvent('onmeasure', _this.onmeasure);
        return _this;
    }
    Object.defineProperty(AreaComponent.prototype, "active", {
        get: function () { return this._active; },
        /**
         * Overall state of the measure component. Values: true = User may draw measure line on map, false = tool is inactive.
         */
        set: function (value) {
            this._active = value;
            value ? this.activate() : this.deactivate();
            this.activeChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AreaComponent.prototype, "autolayer", {
        get: function () { return this._autolayer; },
        /**
         * Boolean flag indicating if the measurement should be turned into a layer automatically when measure is completed
         *
         * @Default false
         */
        set: function (value) {
            this._autolayer = value;
            if (this._autolayer &&
                this.areaMeasurement2D.viewModel.measurement &&
                !this.areaMeasurement2D.viewModel.active) {
                this.addAsLayer(this.areaMeasurement2D.viewModel.measurement, this.areaMeasurement2D.viewModel.measurementLabel);
                this.areaMeasurement2D.viewModel.start();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AreaComponent.prototype, "geodesicDistanceThreshold", {
        get: function () {
            return (this._geodesicDistanceThreshold = this.areaMeasurement2D ? this.areaMeasurement2D.viewModel.geodesicDistanceThreshold : this._geodesicDistanceThreshold);
        },
        /**
         * The threshold distance used by the "auto" mode to switch between planar and geodesic linear computations. The threshold is measured in meters.
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-AreaMeasurement2D-AreaMeasurement2DViewModel.html#geodesicDistanceThreshold)
         *
         */
        set: function (value) {
            this._geodesicDistanceThreshold = value;
            if (this.areaMeasurement2D) {
                this.areaMeasurement2D.viewModel.geodesicDistanceThreshold = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AreaComponent.prototype, "state", {
        get: function () { return this._state; },
        /**
         * State of the measurement tool. Values: 'disabled', 'ready', 'measuring', 'measured'
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-AreaMeasurement2D-AreaMeasurement2DViewModel.html#state)
         */
        set: function (value) {
            this._state = value;
            this.stateChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AreaComponent.prototype, "unit", {
        get: function () {
            return (this._unit = this.areaMeasurement2D ? this.areaMeasurement2D.viewModel.unit : this._unit);
        },
        /**
         * Unit system (imperial, metric) or specific unit used for displaying the distance values.  **Possible Values:** metric | imperial | inches | feet | us-feet | yards | miles | nautical-miles | meters | kilometers
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-AreaMeasurement2D-AreaMeasurement2DViewModel.html#unit)
         *
         * @Default imperial
         */
        set: function (value) {
            this._unit = value;
            if (this.areaMeasurement2D) {
                this.areaMeasurement2D.viewModel.unit = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AreaComponent.prototype, "unitOptions", {
        get: function () {
            return (this._unitOptions = this.areaMeasurement2D ? this.areaMeasurement2D.viewModel.unitOptions : this._unitOptions);
        },
        /**
         * List of available units and unit systems (imperial, metric) for displaying the distance values. By default, the following units are included: `metric`, `imperial`, `inches`, `feet`, `us-feet`, `yards`, `miles`, `nautical-miles`, `meters`, `kilometers`.
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-AreaMeasurement2D-AreaMeasurement2DViewModel.html#unitOptions)
         */
        set: function (value) {
            this._unitOptions = value;
            if (this.areaMeasurement2D) {
                this.areaMeasurement2D.viewModel.unitOptions = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    AreaComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        // Handle defaults
                        this.setupAttributeDefaults(this.areaMeasurementConfigs);
                        if (!this.includeUserDefault) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupUserDefault()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.setProperties(this.areaMeasurementConfigs);
                        return [4 /*yield*/, this.setMapViewRef()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.readyProblem(err_1);
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AreaComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.isReady();
                return [2 /*return*/];
            });
        });
    };
    AreaComponent.prototype.ngOnChanges = function (changes) {
        if (changes.active && !changes.active.firstChange) {
            changes.active.currentValue ? this.activate() : this.deactivate();
            this.activeChange.emit(changes.active.currentValue);
        }
    };
    AreaComponent.prototype.ngOnDestroy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.areaMeasurement2D = null;
                this.areaMeasurementConfigs = null;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Make the distance measurement tool active/shown.
     */
    AreaComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stopInitialCheck_1, _a, err_2;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        if (!!this.areaMeasurement2D) return [3 /*break*/, 2];
                        this.initializing = true;
                        stopInitialCheck_1 = util.debounce(function () { _this.initializing = false; }, initilizeDebounceTime);
                        this.listners.push(this.layerService.mapRef.allLayers.on('before-add', function (event) {
                            if (_this.initializing && event.item.listMode === 'hide') {
                                event.item.set('hideInLegend', true);
                                event.item.set('areaMeasureToolGeneratedLayer', true);
                                stopInitialCheck_1();
                            }
                        }));
                        this.listners.push(this.layerService.mapRef.allLayers.on('after-remove', function (event) {
                            if (event.item.get('areaMeasureToolGeneratedLayer')) {
                                _this.initializing = true;
                            }
                        }));
                        _a = this;
                        return [4 /*yield*/, this._createAreaMeasurement2D(this.areaMeasurementConfigs)];
                    case 1:
                        _a.areaMeasurement2D = _b.sent();
                        this.areaMeasurement2D.viewModel.start();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        this.readyProblem(err_2);
                        throw err_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Make the distance measurement tool inactive/hidden.
     */
    AreaComponent.prototype.deactivate = function () {
        if (this.areaMeasurement2D) {
            this.areaMeasurement2D.destroy();
            this.areaMeasurement2D = null;
        }
        while (this.listners.length) {
            this.listners.pop().remove();
        }
    };
    /**
     * Create a AreaMeasurement2D widgit and return it to caller.
     */
    AreaComponent.prototype._createAreaMeasurement2D = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newElement, AreaMeasurement2D, areaMeasurement2D;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newElement = this.body.nativeElement.appendChild(document.createElement('div'));
                        return [4 /*yield*/, ESRI.AreaMeasurement2D];
                    case 1:
                        AreaMeasurement2D = _a.sent();
                        areaMeasurement2D = new AreaMeasurement2D({
                            container: newElement,
                            viewModel: {
                                unit: config.unit,
                                unitOptions: config.unitOptions,
                                geodesicDistanceThreshold: config.geodesicDistanceThreshold
                            }
                        });
                        areaMeasurement2D.view = this.mapView;
                        this.state = 'ready'; // Widget doesn't call the watcher for its first value; manually set our state
                        // Add watchers
                        areaMeasurement2D.watch('viewModel.state', function (value) {
                            _this.state = value;
                        });
                        areaMeasurement2D.watch('viewModel.active', function (newValue, oldValue) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(!newValue && oldValue && areaMeasurement2D.viewModel)) return [3 /*break*/, 2];
                                        this.onmeasure.emit(areaMeasurement2D.viewModel);
                                        this.state = 'measured'; // ESRI component has code for 'measured' state but does not yet apply it? Manually set for now.
                                        if (!this.autolayer) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.addAsLayer(areaMeasurement2D.viewModel.measurement, areaMeasurement2D.viewModel.measurementLabel)];
                                    case 1:
                                        _a.sent();
                                        this.areaMeasurement2D.viewModel.start();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/, areaMeasurement2D];
                }
            });
        });
    };
    /**
     * Add completed measure geometry as a layer to the map
     */
    AreaComponent.prototype.addAsLayer = function (measurement, label) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Graphic, GraphicsLayer, graphic, layer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Graphic, ESRI.GraphicsLayer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Graphic = _a[0], GraphicsLayer = _a[1];
                        graphic = new Graphic({
                            geometry: measurement.geometry,
                            symbol: {
                                type: 'simple-fill',
                                color: [0, 0, 0],
                                style: 'none',
                                outline: {
                                    color: [0, 128, 255],
                                    style: 'solid',
                                    width: 3
                                }
                            }
                        });
                        layer = new GraphicsLayer({
                            title: "Area: " + label.area,
                            graphics: [graphic]
                        });
                        layer.set('measureLayer', 'area');
                        this.mapView.map.add(layer);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Apply defaults passed in through attributes of this component.
     */
    AreaComponent.prototype.setupAttributeDefaults = function (config) {
        var _this = this;
        ['label', 'toolTip', 'icon', 'color', 'geodesicDistanceThreshold', 'mode', 'unit', 'unitOptions'].forEach(function (prop) {
            if (typeof _this[prop] !== 'undefined') {
                config[prop] = _this[prop];
            }
        });
    };
    /**
     * Apply user specific defaults for this components behavior.
     */
    AreaComponent.prototype.setupUserDefault = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userAreaMeasureConfiguration;
            return tslib_1.__generator(this, function (_a) {
                if (this.includeUserDefault) {
                    userAreaMeasureConfiguration = new AreaMeasurementConfiguration();
                    if (userAreaMeasureConfiguration) {
                        Object.assign(this.areaMeasurementConfigs, userAreaMeasureConfiguration);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Set undefined primary properties of this component with user/config properties.
     */
    AreaComponent.prototype.setProperties = function (config) {
        var _this = this;
        ['label', 'toolTip', 'icon', 'color'].forEach(function (prop) {
            if (typeof _this[prop] === 'undefined' && (typeof config[prop] !== 'undefined')) {
                _this[prop] = config[prop];
            }
        });
    };
    /**
     * Set private reference to this components mapView.
     */
    AreaComponent.prototype.setMapViewRef = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.mapView) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        parent_1 = _a.sent();
                        if (!parent_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, parent_1.ready];
                    case 2:
                        _a.sent();
                        this.mapView = parent_1.mapView;
                        return [3 /*break*/, 4];
                    case 3:
                        this.readyProblem('Map View Reference not supplied and reference from parent element could not be retrieved.');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], AreaComponent.prototype, "active", null);
    tslib_1.__decorate([
        InputConverter(AreaMeasureConfigurationConverter),
        tslib_1.__metadata("design:type", AreaMeasurementConfiguration)
    ], AreaComponent.prototype, "areaMeasurementConfigs", void 0);
    return AreaComponent;
}(BaseComponent));
export { AreaComponent };
